import loadable from "@loadable/component";

export const PostQuoteQuestionnairePage = loadable(
  () => import("./PostQuoteQuestionnairePage"),
  {
    resolveComponent: mod => mod.PostQuoteQuestionnairePage,
  },
);

export * from "./types";
